<template>
  <div>
    <v-stepper v-model="paso" vertical>

      <!-- PASO 1: Datos personales -->
      <v-stepper-step :complete="paso > 1" step="1" color="primary">
        Datos personales
        <small>Nombre, teléfono, correo, edad</small>
      </v-stepper-step>
      <v-stepper-content step="1">
        <v-form ref="formPaso1" v-model="validoPaso1" lazy-validation>
          <v-card flat class="mb-3">
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  label="Nombre completo *"
                  :rules="reglasForm"
                  v-model="datosPersonales.nombre"
                  outlined prepend-inner-icon="mdi-account"
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Teléfono *"
                  :rules="reglasForm"
                  v-model="datosPersonales.telefono"
                  outlined prepend-inner-icon="mdi-phone"
                  type="tel"
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Correo electrónico"
                  v-model="datosPersonales.correo"
                  outlined prepend-inner-icon="mdi-email"
                  type="email"
                  hint="Para notificaciones y publicidad"
                  persistent-hint
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Dirección *"
                  :rules="reglasForm"
                  v-model="datosPersonales.direccion"
                  outlined prepend-inner-icon="mdi-map-marker"
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Edad *"
                  :rules="reglasNumero"
                  v-model.number="datosPersonales.edad"
                  outlined prepend-inner-icon="mdi-cake"
                  type="number" min="5" max="120"
                />
              </v-col>
            </v-row>
          </v-card>
          <v-btn color="primary" rounded @click="avanzar(1)" elevation="2">
            Continuar <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
          <v-btn text to="/miembros" class="ml-2">Cancelar</v-btn>
        </v-form>
      </v-stepper-content>

      <!-- PASO 2: Datos de emergencia -->
      <v-stepper-step :complete="paso > 2" step="2" color="primary">
        Datos de emergencia
        <small>Contacto en caso de accidente</small>
      </v-stepper-step>
      <v-stepper-content step="2">
        <v-form ref="formPaso2" v-model="validoPaso2" lazy-validation>
          <v-card flat class="mb-3">
            <v-row dense>
              <v-col cols="12">
                <v-switch v-model="datosContacto.sufreEnfermedad" label="¿Sufre alguna enfermedad crónica?" color="primary" />
                <v-text-field
                  v-if="datosContacto.sufreEnfermedad"
                  label="Describe las enfermedades"
                  v-model="datosContacto.enfermedad"
                  outlined prepend-inner-icon="mdi-hospital"
                />
              </v-col>
              <v-col cols="12">
                <v-switch v-model="datosContacto.tieneSeguro" label="¿Tiene seguro médico?" color="primary" />
                <v-text-field
                  v-if="datosContacto.tieneSeguro"
                  label="Institución de seguro"
                  v-model="datosContacto.institucion"
                  outlined prepend-inner-icon="mdi-shield-cross"
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Nombre del contacto de emergencia *"
                  :rules="reglasForm"
                  v-model="datosContacto.nombreContacto"
                  outlined prepend-inner-icon="mdi-account-heart"
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Teléfono de emergencia *"
                  :rules="reglasForm"
                  v-model="datosContacto.telefonoContacto"
                  outlined prepend-inner-icon="mdi-phone-alert"
                  type="tel"
                />
              </v-col>
            </v-row>
          </v-card>
          <v-btn color="primary" rounded @click="avanzar(2)" elevation="2">
            Continuar <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
          <v-btn text @click="paso = 1" class="ml-2">
            <v-icon left>mdi-arrow-left</v-icon> Regresar
          </v-btn>
        </v-form>
      </v-stepper-content>

      <!-- PASO 3: Foto -->
      <v-stepper-step step="3" color="primary">
        Foto del miembro
        <small>Opcional pero recomendada</small>
      </v-stepper-step>
      <v-stepper-content step="3">
        <v-card flat class="mb-3">
          <v-row align="center" justify="center">
            <v-col cols="12" sm="6" class="text-center">
              <v-avatar size="140" class="elevation-4 mb-3">
                <img v-if="imagenUrl" :src="imagenUrl" style="object-fit:cover;" />
                <v-icon v-else size="80" color="grey lighten-1">mdi-account-circle</v-icon>
              </v-avatar>
              <v-file-input
                :rules="reglaImagen"
                accept="image/png, image/jpeg, image/bmp, image/webp"
                placeholder="Selecciona una imagen"
                prepend-icon="mdi-camera"
                label="Foto del miembro"
                v-model="imagen"
                outlined
                @change="onSeleccionarImagen"
              />
            </v-col>
          </v-row>
        </v-card>
        <v-btn
          color="success" x-large rounded @click="registrar" elevation="4"
          :loading="registrando"
        >
          <v-icon left>mdi-content-save</v-icon> Registrar Miembro
        </v-btn>
        <v-btn text @click="paso = 2" class="ml-2">
          <v-icon left>mdi-arrow-left</v-icon> Regresar
        </v-btn>
      </v-stepper-content>

    </v-stepper>
  </div>
</template>

<script>
export default {
  name: 'FormMiembro',
  props: ['miembro', 'registrando'],

  data: function() {
    return {
      paso: 1,
      validoPaso1: false,
      validoPaso2: false,
      imagen: null,
      imagenUrl: null,
      reglasForm: [function(v) { return !!v || 'Este campo es requerido' }],
      reglasNumero: [
        function(v) { return (v !== '' && v !== null && v !== undefined) || 'Requerido' },
        function(v) { return parseInt(v) > 0 || 'Debe ser mayor a 0' },
      ],
      reglaImagen: [function(v) { return !v || v.size < 5000000 || 'La foto debe pesar menos de 5 MB' }],
      datosPersonales: {
        nombre: '', telefono: '', correo: '', direccion: '', edad: 18,
      },
      datosContacto: {
        sufreEnfermedad: false, tieneSeguro: false,
        enfermedad: '', institucion: '',
        nombreContacto: '', telefonoContacto: '',
      },
    }
  },

  mounted: function() {
    this.reiniciar()
  },

  methods: {
    avanzar: function(numeroPaso) {
      var ref = numeroPaso === 1 ? this.$refs.formPaso1 : this.$refs.formPaso2
      if (ref && ref.validate()) {
        this.paso = numeroPaso + 1
      }
    },

    registrar: function() {
      var miembro = Object.assign({}, this.datosPersonales, this.datosContacto, {
        imagen: this.imagenUrl,
      })
      this.$emit('registrado', miembro)
      // El padre controla cuándo reiniciar (cuando llegue confirmación)
    },

    reiniciar: function() {
      this.paso = 1
      this.imagen = null
      this.imagenUrl = null
      this.validoPaso1 = false
      this.validoPaso2 = false
      this.datosPersonales = { nombre: '', telefono: '', correo: '', direccion: '', edad: 18 }
      this.datosContacto = {
        sufreEnfermedad: false, tieneSeguro: false,
        enfermedad: '', institucion: '',
        nombreContacto: '', telefonoContacto: '',
      }
      if (this.$refs.formPaso1) this.$refs.formPaso1.resetValidation()
      if (this.$refs.formPaso2) this.$refs.formPaso2.resetValidation()
    },

    onSeleccionarImagen: function() {
      if (!this.imagen) { this.imagenUrl = null; return }
      var self = this
      var reader = new FileReader()
      reader.onload = function(e) { self.imagenUrl = e.target.result }
      reader.readAsDataURL(this.imagen)
    },
  },

  watch: {
    miembro: {
      deep: true,
      handler: function(val) {
        if (!val) return
        if (val.datosPersonales) this.datosPersonales = Object.assign({}, val.datosPersonales)
        if (val.datosContacto) this.datosContacto = Object.assign({}, val.datosContacto)
      },
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Miembros/FormMiembro.vue